function envValue(key: string) {
  if (typeof process !== "undefined" && process.env?.[key]) return process.env[key]
  return import.meta.env?.[key]
}

export {
  type DateInput,
  unixMsDate,
  utcDate,
  utcDateOnly,
  utcDayjs,
  utcIsoString,
  utcNow,
  utcObjectKeyTimestamp,
  utcPathParts,
  utcUnixMs,
} from "./date"

export function isDevStage(stage = envValue("PUBLIC_STAGE")) {
  return !stage || stage === "dev" || stage === "local"
}

export function dashboardDomain(stage = envValue("PUBLIC_STAGE")) {
  if (stage === "dev") return "dev.dashboard.playbrain.com"
  if (stage === "staging") return "staging.dashboard.playbrain.com"
  if (stage === "prod") return "dashboard.playbrain.com"
  return "localhost:3000"
}

export function dashboardUrl(stage = envValue("PUBLIC_STAGE")) {
  const domain = dashboardDomain(stage)
  return domain.startsWith("localhost") ? `http://${domain}/dashboard` : `https://${domain}`
}

export function dashboardLoginUrl(stage = envValue("PUBLIC_STAGE")) {
  const domain = dashboardDomain(stage)
  return domain.startsWith("localhost") ? `http://${domain}/login` : `https://${domain}/login`
}
